import React from 'react';
import { Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const SearchTableRow = ({ loading, staffs, path, classes }) => {
  return (
    <tbody>
      {/* eslint-disable-next-line no-nested-ternary */}
      {loading ? (
        <tr className="py-3">
          <td colSpan={7}>
            <div className="d-flex justify-content-center w-100">
              <Spinner className="spinner" animation="border" variant="dark" />
            </div>
          </td>
        </tr>
      ) : staffs && staffs.length > 0 ? (
        staffs.map((staff) => (
          <tr key={staff.staff_no}>
            <td>
              {staff.lastname} {staff.firstname}
            </td>
            <td>{staff.designation}</td>
            <td style={{ color: staff.status === 'Active' ? 'green' : 'red' }}>{staff.status}</td>
            <td>
              <Link
                to={`${path}/${staff.staff_id}`}
                // onClick={() => setBackLink('/createcin')}
                className={`w-100 btn ${classes.staff_table_tablebutton}`}>
                View
              </Link>
            </td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan={7} className="w-100 text-center">
            No Data
          </td>
        </tr>
      )}
    </tbody>
  );
};

export default SearchTableRow;
